


import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";

import BreakpointService from "@/shared/services/breakpoint-service"
import { Breakpoint } from "@/shared/models/breakpoint-type";

@Component({
    computed: {
        ...mapGetters(["config", "searchQuery", "searchActive", "externalSearchEnabled"])
    }    
})

export default class FormComponent extends Vue {
    @Prop() configRaw!: string;

    private query: string = '';
    public isExternalActive: boolean = true;
    public bodyEle: HTMLElement = document.body;
    public header: HTMLElement | null = document.querySelector("#header-wrapper");
    public breakpoint: Breakpoint = BreakpointService.currentBreakpoint;

    get placeholderText(): string {
        return this.isExternalActive ? this.$store.getters.config.labels.placeholder_libsearch : this.$store.getters.config.labels.placeholder;
    }

    @Watch('query')
    onPropertyChanged() {
       this.onChange();
    }

    @Watch('isExternalActive')
    onExternalSearchPropertyChanged() {
       this.onExternalSearchChange();
    }

    @Watch('externalSearchEnabled')
    onExternalSearchEnabledPropertyChanged() {
        this.isExternalActive = this.$store.getters.externalSearchEnabled;
    }

    mounted() {
        this.init();
    }

    private init(): void {
        this.setHeaderZIndex();

        window.addEventListener("resize", () => {
            this.breakpoint = BreakpointService.currentBreakpoint;
            this.setHeaderZIndex();
        });
    }

    /* Disable search on ENTER for internal search*/
    private sendSearch(e: Event): void {
        if (this.isExternalActive) {
            let url =  `${this.$store.getters.externalSearch.overviewUrl || ""}${this.query}`;
            window.open(url, "_blank");
        }

        e.preventDefault();
    }

    private setSearchActive(status: boolean): void {
        this.$store.commit('setSearchActive', status);

        if (status === false) {
            this.query = '';
            this.$store.commit('setSearchQuery', this.query);
            this.bodyEle.classList.remove('vuw-overflow-y-hide-small');
        } else {
            this.bodyEle.classList.add('vuw-overflow-y-hide-small');
            setTimeout(() => {
                if (window.innerWidth < 1400) {
                    window.scrollTo(0, 0);
                }
            }, 500);
        }

        this.setHeaderZIndex();
    }

    private setHeaderZIndex() {
        if(this.breakpoint != Breakpoint.Desktop) {
            if(this.$store.getters.searchActive == true) {
                this.header?.style.setProperty("z-index", "0");
            } else {
                this.header?.style.setProperty("z-index", "30");
            }
        }
    }

    private onChange(): void {
        this.$store.commit('setSearchQuery', this.query);
    }

    private onExternalSearchChange(): void {
        this.$store.commit('setExternalSearchOption', this.isExternalActive);
    }
}
